import { Box, Paper, Typography, alpha } from '@mui/material';
import { monoSx } from '../../../../helperComponents/showPrimitives';
import {
  INGEST_RUN_STUCK_MESSAGE,
  INGEST_RUN_NO_ERROR_TEXT
} from '../../../../../helpers/adsIngestRunsConstants';

const getErrorText = (record) => {
  if (typeof record.error === 'string' && record.error) return record.error;
  if (record.display_status === 'stuck') return INGEST_RUN_STUCK_MESSAGE;
  if (record.display_status === 'error') return INGEST_RUN_NO_ERROR_TEXT;
  return null;
};

export const RunError = ({ record }) => {
  const text = getErrorText(record);
  if (!text) return null;

  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 3,
        p: 3,
        mb: 2,
        bgcolor: (t) => alpha(t.palette.error.main, 0.08),
        borderColor: (t) => alpha(t.palette.error.main, 0.3)
      }}
    >
      <Typography variant="h6" fontWeight={600} color="error.main" sx={{ mb: 1 }}>Error</Typography>
      <Box component="pre" sx={{ ...monoSx, wordBreak: 'break-word' }}>{text}</Box>
    </Paper>
  );
};
